export const SET_RESULT = 'SET_RESULT';

function _setResult(item, q) {
  return { type: SET_RESULT, payload: { item, q }};
}

export const setResult = (item, q) => (dispatch) => {
  return dispatch(_setResult(item, q));
}



// WEBPACK FOOTER //
// ./src/state/actions/questionnaireActions.js